import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";

export const SuccessIcon = CheckCircleIcon;
export { WarningIcon };
export { ErrorIcon };
export { InfoIcon };
